module.exports = __webpack_public_path__ + "media/sample.699f9621.mp3";